"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.overlayTemplate = void 0;
var tslib_1 = require("tslib");
var overlay_dot_1 = (0, tslib_1.__importDefault)(require("./overlay.dot"));
var overlayTemplate = overlay_dot_1.default.default ? overlay_dot_1.default.default : overlay_dot_1.default;
exports.overlayTemplate = overlayTemplate;
//# sourceMappingURL=index.js.map